export default __webpack_public_path__ + "static/media/m-bottom-img-service-online.1955a905.png";